function scrollSize(element, addCssVariables = false) {
	let div

	if (element === undefined || element === ':root' || element === 'html') {
		div = document.createElement('div')
		div.style.width = '50px'
		div.style.height = '50px'
		div.classList.add('scrollSize')
		if (window.innerWidth !== document.documentElement.clientWidth) {
			div.style.overflow = 'scroll'
		}
		document.body.append(div)

	} else {
		div = element
	}

	const scrollSize = {
		width: div.offsetWidth - div.clientWidth,
		height: div.offsetHeight - div.clientHeight
	}

	if (addCssVariables !== false) {
		$(element).css({
			'--scroll-size_w': `${ scrollSize.width }px`,
			'--scroll-size_h': `${ scrollSize.height }px`
		})
	}

	if (element === undefined || element === ':root' || element === 'html') {
		div.remove()
	}
	return scrollSize
}

window.scrollSize = scrollSize
